import { DesignSystemProvider } from '@taxfix/ds-theme'
import { useEffect, useState, ReactNode } from 'react'

import Bookkeeping from '@taxfix/scouts-books'

import { useBookkeepingData } from '@/hooks/use-bookkeeping-data'
import { usePostHogFeatureFlags } from '@/hooks/use-posthog-feature-flags'

import { BookkeepingConfigurationContext, DEFAULT_CONTEXT } from './BookkeepingConfigurationContext'
import { useFilters } from './use-filters'

interface BookkeepingConfigurationProviderProps {
    children: ReactNode
}

export const BookkeepingConfigurationProvider = ({ children }: BookkeepingConfigurationProviderProps) => {
    const contextData = useState(DEFAULT_CONTEXT)
    const [config, setConfig] = contextData
    const data = useBookkeepingData()
    const { filters: availableDateRangeFilterShortcuts } = useFilters()
    const { featureSelfAssessmentDocumentsSimplifiedView, featureInvoicePricesIncludeVAT } = usePostHogFeatureFlags()

    useEffect(() => {
        setConfig((currentConfig) => ({
            ...currentConfig,
            availableDateRangeFilterShortcuts,
            featureFlags: {
                ...currentConfig.featureFlags,
                featureSelfAssessmentDocumentsSimplifiedView,
                featureInvoicePricesIncludeVAT,
            },
        }))
    }, [
        availableDateRangeFilterShortcuts,
        featureSelfAssessmentDocumentsSimplifiedView,
        featureInvoicePricesIncludeVAT,
        setConfig,
    ])

    return (
        <BookkeepingConfigurationContext.Provider value={contextData}>
            <Bookkeeping.StoreProvider config={config} data={data}>
                <DesignSystemProvider theme="taxfix-global">{children}</DesignSystemProvider>
            </Bookkeeping.StoreProvider>
        </BookkeepingConfigurationContext.Provider>
    )
}
